import React, { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { LanguageToggle } from "./LanguageToggle";

export const Nav = ({ lang, setLang, t }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#e7e7e5]/85 backdrop-blur-md border-b border-stone-300/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="https://www.instagram.com/amme.estate"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-instagram-link"
          className={`flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] transition-colors ${
            scrolled ? "text-stone-900 hover:text-[#3d3d3b]" : "text-white/90 hover:text-white"
          }`}
        >
          <Instagram size={14} strokeWidth={1.5} />
          <span className="hidden sm:inline">{t.nav.instagram}</span>
        </a>

        <div
          className={`font-serif tracking-[0.4em] text-sm md:text-base transition-colors ${
            scrolled ? "text-stone-900" : "text-white"
          }`}
          data-testid="nav-brand"
        >
          AMMÉ
        </div>

        <div className={scrolled ? "" : "[&_button]:text-white [&_button:hover]:text-white/70"}>
          <LanguageToggle lang={lang} setLang={setLang} />
        </div>
      </div>
    </header>
  );
};
